import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Chart from "react-apexcharts";
import PageTitleAndSnackBar from '../components/common/PageTitleAndSnackBar';
import DContext from '../context/DContext';
import AlertBox from '../components/alert/AlertBox';
import OffcanvasComponent from '../components/offcanvas/OffCanvasComponent';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'


const MySwal = withReactContent(Swal)


const Homepage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let { query } = useParams();

  const url = window.location.href;
  const pathname = window.location.pathname;
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;

  const [searchParams, setSearchParams] = useSearchParams();

  const {
    commonState,
    commonDispatch,
    fun1,
    fun2,
  } = useContext(DContext);

  const { alertArr } = commonState;
  const [count, setCount] = useState(1);
  const [selectedPeriod, setSelectedPeriod] = useState('today');

  const [dashboardData, setDashboardData] = useState({
    agents: {
      total: 1244, change: -12, trend: 'decrease',
      data: {
        today: { total: 15, change: 5 },
        thisMonth: { total: 324, change: 8 },
        thisYear: { total: 1244, change: -12 }
      }
    },
    bookings: {
      total: 145, change: 12, trend: 'increase',
      data: {
        today: { total: 145, change: 12 },
        thisMonth: { total: 3420, change: 18 },
        thisYear: { total: 28500, change: 22 }
      }
    },
    flights: {
      total: 89, change: 8, trend: 'increase',
      data: {
        today: { total: 89, change: 8 },
        thisMonth: { total: 2340, change: 15 },
        thisYear: { total: 18750, change: 25 }
      }
    },
    revenue: {
      total: 326400, change: 15, trend: 'increase',
      data: {
        today: { total: 126400, change: 8 },
        thisMonth: { total: 3264000, change: 15 },
        thisYear: { total: 28540000, change: 22 }
      }
    }
  });

  const [recentBookings] = useState([
    { id: 'BK2024001', passenger: 'John Smith', route: 'DEL → BOM', flight: 'AI-101', date: '2025-09-28', amount: 15450, status: 'Confirmed', agent: 'Travel Connect Ltd.' },
    { id: 'BK2024002', passenger: 'Sarah Johnson', route: 'BOM → CCU', flight: 'SG-205', date: '2025-09-29', amount: 12800, status: 'Pending', agent: 'Sky Travel Solutions' },
    { id: 'BK2024003', passenger: 'Raj Patel', route: 'DEL → GOA', flight: 'AI-147', date: '2025-09-30', amount: 18900, status: 'Confirmed', agent: 'Global Tours' },
    { id: 'BK2024004', passenger: 'Emily Davis', route: 'CCU → DEL', flight: 'SG-108', date: '2025-10-01', amount: 14200, status: 'Cancelled', agent: 'Metro Travel' },
    { id: 'BK2024005', passenger: 'Michael Brown', route: 'BOM → GOA', flight: 'AI-233', date: '2025-10-02', amount: 9800, status: 'Confirmed', agent: 'Holiday Express' },
  ]);

  let chartstate = {
    options: {
      chart: { id: "booking-trends", toolbar: { show: false } },
      xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'] },
      colors: ['#2d4f8e', '#5b84c4'],
      stroke: { curve: 'smooth', width: 3 },
      fill: {
        type: 'gradient',
        gradient: { shadeIntensity: 1, opacityFrom: 0.5, opacityTo: 0.1 }
      }
    },
    series: [
      { name: "Bookings", data: [1200, 1580, 1420, 1890, 2100, 1950, 2340, 2180, 2450] },
      { name: "Revenue (₹ in thousands)", data: [180, 230, 210, 285, 315, 292, 351, 327, 367] }
    ]
  };

  let piechart = {
    options: {
      labels: ['Delhi', 'Mumbai', 'Bangalore', 'Chennai', 'Kolkata', 'Others'],
      colors: ['#2d4f8e', '#5b84c4', '#3a8f65', '#c47c1a', '#c45252', '#8a9ab5'],
      legend: { position: 'bottom' }
    },
    series: [35, 28, 15, 12, 8, 2]
  };

  const [topRoutes] = useState([
    { route: 'DEL → BOM', bookings: 342, revenue: 4890000, growth: 15 },
    { route: 'BOM → DEL', bookings: 298, revenue: 4250000, growth: 12 },
    { route: 'DEL → BLR', bookings: 245, revenue: 3680000, growth: 8 },
    { route: 'BOM → GOA', bookings: 189, revenue: 2340000, growth: 22 },
    { route: 'CCU → DEL', bookings: 156, revenue: 1980000, growth: -5 }
  ]);

  useEffect(() => {}, [])

  const addAlert = () => {
    commonDispatch({ type: "ADD_ALERT", payload: { variant: "danger", message: count } });
    setCount(count + 1);
  }

  const [inputValue, setInputValue] = useState('')

  const showSwal = () => {
    withReactContent(Swal).fire({
      title: "Deleted!", text: "Your file has been deleted.", icon: "success"
    })
  }

  // Reusable section header icon box — soft fill instead of dark gradient
  const SectionIcon = ({ icon }) => (
    <div style={{
      width: "34px", height: "34px", borderRadius: "10px",
      background: "#e8edf8",
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <i className={`bi ${icon}`} style={{ fontSize: "14px", color: "#1e3a6e" }}></i>
    </div>
  );

  return (
    <>
      <PageTitleAndSnackBar pageTitle="Dashboard" />
      <AlertBox />

      <section className="section dashboard">
        <div className="row g-3">

          {/* ── Stat Cards ── */}
          {[
            {
              to: "/agents", label: "Travel Agents", period: "This Year",
              icon: "bi-people-fill", iconBg: "#fef9ec", iconColor: "#b45309",
              value: dashboardData.agents.total.toLocaleString(),
              change: dashboardData.agents.change, trend: dashboardData.agents.trend,
              borderTop: "#e8b84b"
            },
            {
              to: "/bookings", label: "Bookings", period: "Today",
              icon: "bi-ticket-perforated-fill", iconBg: "#eef0ff", iconColor: "#2d4f8e",
              value: dashboardData.bookings.total,
              change: dashboardData.bookings.change, trend: "increase",
              borderTop: "#5b84c4"
            },
            {
              to: "/flights", label: "Active Flights", period: "Today",
              icon: "bi-airplane-fill", iconBg: "#e8f5fe", iconColor: "#0e7ab8",
              value: dashboardData.flights.total,
              change: dashboardData.flights.change, trend: "increase",
              borderTop: "#4faad6"
            },
            {
              to: "/revenue", label: "Revenue", period: "This Month",
              icon: "bi-currency-rupee", iconBg: "#edfaf4", iconColor: "#1a7a55",
              value: `₹${(dashboardData.revenue.data.thisMonth.total / 1000).toFixed(0)}K`,
              change: dashboardData.revenue.change, trend: "increase",
              borderTop: "#3aaa7a"
            },
          ].map((stat, i) => (
            <div className="col-xxl-3 col-md-6" key={i}>
              <Link to={stat.to} style={{ textDecoration: "none" }}>
                <div className="card border-0 shadow-sm h-100"
                  style={{ borderRadius: "16px", borderTop: `3px solid ${stat.borderTop}`, transition: "transform 0.15s, box-shadow 0.15s" }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(15,37,87,0.09)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = ""; }}
                >
                  <div className="card-body p-3">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div>
                        <p className="mb-0" style={{ fontSize: "11px", fontWeight: "700", color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.7px" }}>
                          {stat.label}
                        </p>
                        <span style={{ fontSize: "10px", color: "#a0aec0" }}>{stat.period}</span>
                      </div>
                      <div style={{
                        width: "42px", height: "42px", borderRadius: "12px",
                        background: stat.iconBg, flexShrink: 0,
                        display: "flex", alignItems: "center", justifyContent: "center"
                      }}>
                        <i className={`bi ${stat.icon}`} style={{ fontSize: "18px", color: stat.iconColor }}></i>
                      </div>
                    </div>
                    <h4 className="fw-bold mb-1" style={{ color: "#1e3a6e", fontSize: "22px" }}>{stat.value}</h4>
                    <div className="d-flex align-items-center gap-1">
                      <span style={{
                        fontSize: "11px", fontWeight: "700", borderRadius: "6px", padding: "2px 7px",
                        background: stat.change > 0 ? "#edfaf4" : "#fff4f4",
                        color: stat.change > 0 ? "#1a7a55" : "#c45252"
                      }}>
                        <i className={`bi ${stat.change > 0 ? "bi-arrow-up" : "bi-arrow-down"}`}></i> {Math.abs(stat.change)}%
                      </span>
                      <span style={{ fontSize: "11px", color: "#a0aec0" }}>{stat.trend}</span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}

          {/* ── Booking Trends Chart ── */}
          <div className="col-xxl-8 col-xl-12">
            <div className="card border-0 shadow-sm h-100" style={{ borderRadius: "16px" }}>
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <SectionIcon icon="bi-graph-up-arrow" />
                    <div>
                      <h6 className="mb-0 fw-bold" style={{ color: "#1e3a6e", fontSize: "14px" }}>Booking Trends & Revenue</h6>
                      <span style={{ fontSize: "11px", color: "#a0aec0" }}>This Year</span>
                    </div>
                  </div>
                </div>
                <Chart options={{
                  ...chartstate.options,
                  colors: ['#2d4f8e', '#5b84c4'],
                  chart: { ...chartstate.options.chart, toolbar: { show: false } },
                  grid: { borderColor: "#f0f2f8", strokeDashArray: 4 },
                  xaxis: { ...chartstate.options.xaxis, labels: { style: { colors: "#a0aec0", fontSize: "11px" } } },
                  yaxis: { labels: { style: { colors: "#a0aec0", fontSize: "11px" } } },
                  tooltip: { theme: "light" }
                }} series={chartstate.series} type="area" height="320" />
              </div>
            </div>
          </div>

          {/* ── Top Cities Donut ── */}
          <div className="col-xxl-4 col-xl-12">
            <div className="card border-0 shadow-sm h-100" style={{ borderRadius: "16px" }}>
              <div className="card-body p-4">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <SectionIcon icon="bi-pie-chart-fill" />
                  <div>
                    <h6 className="mb-0 fw-bold" style={{ color: "#1e3a6e", fontSize: "14px" }}>Top Cities</h6>
                    <span style={{ fontSize: "11px", color: "#a0aec0" }}>Bookings Distribution</span>
                  </div>
                </div>
                <Chart options={{
                  ...piechart.options,
                  colors: ['#2d4f8e', '#5b84c4', '#3a8f65', '#c47c1a', '#c45252', '#8a9ab5'],
                  legend: { position: 'bottom', fontSize: '12px', labels: { colors: '#4b5563' } },
                  dataLabels: { style: { fontSize: '11px' } }
                }} series={piechart.series} type="donut" height="320" />
              </div>
            </div>
          </div>

          {/* ── Recent Bookings Table ── */}
          <div className="col-xxl-8 col-xl-12">
            <div className="card border-0 shadow-sm" style={{ borderRadius: "16px" }}>
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <SectionIcon icon="bi-ticket-perforated-fill" />
                    <div>
                      <h6 className="mb-0 fw-bold" style={{ color: "#1e3a6e", fontSize: "14px" }}>Recent Bookings</h6>
                      <span style={{ fontSize: "11px", color: "#a0aec0" }}>Latest transactions</span>
                    </div>
                  </div>
                  <Link to="/bookings">
                    <button className="btn btn-sm fw-semibold d-flex align-items-center gap-2"
                      style={{
                        background: "#f4f6fb", color: "#4b5563",
                        border: "1.5px solid #dde3ef", borderRadius: "8px",
                        fontSize: "12px", height: "32px", padding: "0 14px"
                      }}>
                      View All <i className="bi bi-arrow-right" style={{ color: "#2d4f8e" }}></i>
                    </button>
                  </Link>
                </div>

                <div className="table-responsive">
                  <table className="table mb-0" style={{ fontSize: "13px" }}>
                    <thead>
                      <tr style={{ background: "#f8f9fd" }}>
                        {["Booking ID", "Passenger", "Route", "Flight", "Amount", "Status"].map((h, i) => (
                          <th key={i} style={{
                            fontSize: "11px", fontWeight: "700", color: "#a0aec0",
                            textTransform: "uppercase", letterSpacing: "0.6px",
                            border: "none", padding: "10px 12px", background: "#f8f9fd"
                          }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {recentBookings.map((booking, index) => {
                        const statusStyle = {
                          Confirmed: { bg: "#edfaf4", color: "#1a7a55" },
                          Pending: { bg: "#fef9ec", color: "#b45309" },
                          Cancelled: { bg: "#fff4f4", color: "#c45252" },
                        }[booking.status] || { bg: "#f4f6fb", color: "#4b5563" };

                        return (
                          <tr key={index} style={{ borderBottom: "1px solid #f0f2f8", verticalAlign: "middle" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#f8f9fe"}
                            onMouseLeave={e => e.currentTarget.style.background = ""}
                          >
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                background: "#eef0ff", color: "#2d4f8e",
                                borderRadius: "6px", padding: "2px 8px",
                                fontSize: "11px", fontWeight: "700"
                              }}>{booking.id}</span>
                            </td>
                            <td style={{ padding: "10px 12px", fontWeight: "600", color: "#1e3a6e" }}>
                              <div className="d-flex align-items-center gap-2">
                                <div style={{
                                  width: "26px", height: "26px", borderRadius: "50%",
                                  background: "#eef0ff", display: "flex",
                                  alignItems: "center", justifyContent: "center", flexShrink: 0
                                }}>
                                  <i className="bi bi-person-fill" style={{ fontSize: "11px", color: "#2d4f8e" }}></i>
                                </div>
                                {booking.passenger}
                              </div>
                            </td>
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                background: "#f4f6fb", color: "#4b5563",
                                borderRadius: "6px", padding: "3px 10px",
                                fontSize: "12px", fontWeight: "600"
                              }}>
                                <i className="bi bi-airplane-fill me-1" style={{ color: "#2d4f8e", fontSize: "10px" }}></i>
                                {booking.route}
                              </span>
                            </td>
                            <td style={{ padding: "10px 12px", color: "#4b5563", fontWeight: "600" }}>{booking.flight}</td>
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                background: "#edfaf4", color: "#1a7a55",
                                borderRadius: "6px", padding: "3px 8px",
                                fontSize: "12px", fontWeight: "700"
                              }}>₹{booking.amount.toLocaleString()}</span>
                            </td>
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                fontSize: "10px", fontWeight: "700", borderRadius: "6px",
                                padding: "3px 9px", background: statusStyle.bg, color: statusStyle.color
                              }}>
                                {booking.status.toUpperCase()}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* ── Top Routes ── */}
          <div className="col-xxl-4 col-xl-12">
            <div className="card border-0 shadow-sm h-100" style={{ borderRadius: "16px" }}>
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <SectionIcon icon="bi-map-fill" />
                    <div>
                      <h6 className="mb-0 fw-bold" style={{ color: "#1e3a6e", fontSize: "14px" }}>Top Routes</h6>
                      <span style={{ fontSize: "11px", color: "#a0aec0" }}>This Month</span>
                    </div>
                  </div>
                  <Link to="/routes">
                    <button className="btn btn-sm fw-semibold d-flex align-items-center gap-2"
                      style={{
                        background: "#f4f6fb", color: "#4b5563",
                        border: "1.5px solid #dde3ef", borderRadius: "8px",
                        fontSize: "12px", height: "32px", padding: "0 14px"
                      }}>
                      View All <i className="bi bi-arrow-right" style={{ color: "#2d4f8e" }}></i>
                    </button>
                  </Link>
                </div>

                <div className="d-flex flex-column gap-2">
                  {topRoutes.map((route, index) => (
                    <div key={index}
                      style={{
                        padding: "12px 14px", borderRadius: "12px",
                        border: "1.5px solid #f0f2f8", background: "white",
                        transition: "all 0.15s", cursor: "default"
                      }}
                      onMouseEnter={e => { e.currentTarget.style.background = "#f8f9fe"; e.currentTarget.style.borderColor = "#dde3ef"; }}
                      onMouseLeave={e => { e.currentTarget.style.background = "white"; e.currentTarget.style.borderColor = "#f0f2f8"; }}
                    >
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <div style={{
                            width: "32px", height: "32px", borderRadius: "9px",
                            background: "#eef0ff", flexShrink: 0,
                            display: "flex", alignItems: "center", justifyContent: "center"
                          }}>
                            <i className="bi bi-airplane-fill" style={{ fontSize: "13px", color: "#2d4f8e" }}></i>
                          </div>
                          <span style={{ fontWeight: "700", fontSize: "13px", color: "#1e3a6e" }}>{route.route}</span>
                        </div>
                        <span style={{
                          fontSize: "11px", fontWeight: "700", borderRadius: "6px", padding: "2px 8px",
                          background: route.growth > 0 ? "#edfaf4" : "#fff4f4",
                          color: route.growth > 0 ? "#1a7a55" : "#c45252"
                        }}>
                          <i className={`bi ${route.growth > 0 ? "bi-arrow-up" : "bi-arrow-down"}`}></i>
                          {route.growth > 0 ? "+" : ""}{route.growth}%
                        </span>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <span style={{ fontSize: "11px", color: "#6b7280" }}>
                          <i className="bi bi-ticket-perforated me-1" style={{ color: "#a0aec0" }}></i>
                          {route.bookings} bookings
                        </span>
                        <span style={{ fontSize: "11px", fontWeight: "600", color: "#1a7a55" }}>
                          <i className="bi bi-currency-rupee" style={{ fontSize: "10px" }}></i>
                          {(route.revenue / 1000).toFixed(0)}K revenue
                        </span>
                      </div>

                      {/* Progress bar */}
                      <div className="mt-2" style={{ height: "4px", background: "#eef0f8", borderRadius: "4px", overflow: "hidden" }}>
                        <div style={{
                          height: "100%", borderRadius: "4px",
                          width: `${(route.bookings / topRoutes[0].bookings) * 100}%`,
                          background: "#5b84c4",
                          transition: "width 0.4s ease"
                        }}></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default Homepage;